import withDirectionDetail from "../withDirectionDetail";
import DirectionSamplingForm from "./DirectionSamplingForm";
import DirectionSamplingPDFGenerator from "./DirectionSamplingPDFGenerator";

const directionFormKazakhName = 'Сынама үлгілерін вирусологиялық зерттеулерге (инфекция түрін көрсетініз)'
const directionFormName = 'НАПРАВЛЕНИЕ на исследование образцов проб на вирусологическое исследование'
const directionFormNumber = '016'
const directionName = 'DirectionSampling'

export default withDirectionDetail(DirectionSamplingForm, DirectionSamplingPDFGenerator, directionFormKazakhName,  directionFormName,  directionFormNumber, directionName)